module.exports = __webpack_public_path__ + "public/img/12.64045cf6.png";